
import { defineComponent, onMounted } from 'vue';
import { AppCard } from '@/components';
import { usePromotionCycleDetail } from '@/modules/promotion/cycle/model/detail';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { statusOption } from '@/modules/promotion/cycle/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.CYCLE.DETAIL,
    components: { AppCard },
    setup() {
        const { model, fetch } = usePromotionCycleDetail();

        onMounted(async () => {
            await fetch();
        });

        return { model, statusOption, formatDate, renderOption };
    }
});
